import { fallback } from "@tanstack/zod-adapter";
import { z } from "zod";

/**
 * Typed router id for the end-user tools (catalog) list route. Centralized so the
 * list and its create sheet agree on one string and can't silently drift.
 */
export const CATALOG_ROUTE_ID =
  "/_authenticated/orgs/$organizationId/projects/$projectId/catalog" as const;

export const catalogSearchSchema = z.object({
  /** When true, the "Add grant" sheet auto-opens on load (deep-linkable). */
  create: fallback(z.boolean(), false).default(false),
});

export type CatalogSearch = z.infer<typeof catalogSearchSchema>;

export const catalogSearchDefaults: CatalogSearch = {
  create: false,
};
